export const QA_NAME_LISTING_FORM_PORTALS_HINT = 'listingFormPortalsHint'

export const QA_NAME_LISTING_FORM_PORTAL_CHECKBOX = 'listingFormPortalCheckbox'

export const LISTING_FORM_PORTALS_SKELETON_ROWS_LENGTH = 3
